// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2N2o9","search":"Settings_search__3UXBc","filter":"Settings_filter__2rYiM"};